import type { MutableRefObject } from 'react';

import type { DocumentDraft } from '@/entities/document-draft';

export type DraftSaveCallbacks = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export type PendingDraftSave = DraftSaveCallbacks & {
  drafts: DocumentDraft[];
};

export function getDocumentDraftKey(document: DocumentDraft): string {
  return JSON.stringify(document.content);
}

export function replaceDraft(drafts: DocumentDraft[], draft: DocumentDraft): DocumentDraft[] {
  return [...drafts.filter((candidate) => candidate.id !== draft.id), draft].sort((a, b) =>
    b.updatedAt.localeCompare(a.updatedAt)
  );
}

export type DraftRef = MutableRefObject<DocumentDraft | null>;
